import { gql } from '@apollo/client';
import { useMemo } from 'react';

import { useQuery } from 'shared/hooks';

export const INSIGHT_TAG_OPTIONS_QUERY = gql`
  query InsightTagOptionsOperation {
    insightTagOptions {
      value
      label
    }
  }
`;

export const ENTITY_TAG_OPTIONS_QUERY = gql`
  query EntityTagOptionsOperation {
    entityTagOptions {
      value
      label
    }
  }
`;

export const SIGNAL_TAG_OPTIONS_QUERY = gql`
  query SignalTagOptionsOperation {
    signalTagOptions {
      value
      label
    }
  }
`;

const RULE_TAG_OPTIONS_QUERY = gql`
  query RuleTagOptionsOperation {
    ruleTagOptions {
      value
      label
    }
  }
`;

const optionQueries = {
  insight: INSIGHT_TAG_OPTIONS_QUERY,
  entity: ENTITY_TAG_OPTIONS_QUERY,
  signal: SIGNAL_TAG_OPTIONS_QUERY,
  rules: RULE_TAG_OPTIONS_QUERY,
  customInsight: RULE_TAG_OPTIONS_QUERY,
};

const optionResultProps = {
  insight: 'insightTagOptions',
  entity: 'entityTagOptions',
  signal: 'signalTagOptions',
  rules: 'ruleTagOptions',
  customInsight: 'ruleTagOptions',
};
export const useTagOptions = (source?: string) => {
  const optionQuery =
    source && optionQueries[source]
      ? optionQueries[source]
      : INSIGHT_TAG_OPTIONS_QUERY;
  const optionProp =
    source && optionResultProps[source]
      ? optionResultProps[source]
      : 'insightTagOptions';

  const { data, loading } = useQuery(optionQuery, { skip: !source });

  const tagOptions: string[] = useMemo(() => {
    if (data && data[optionProp]) {
      return data[optionProp].reduce((options, { value, label }) => {
        if (!label) {
          options.push(value);
        }
        return options;
      }, []);
    }
    return [];
  }, [data, optionProp]);

  return { tagOptions, loading };
};
